import "../util/functions";

let phone_extension = window.queryParam("ext");
if (phone_extension !== null) {
    phone_extension = phone_extension.replaceAll(' ', '');
} else {
    phone_extension = '1';
}

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
};

const config = {
    phone_extension: '+' + phone_extension,
    api_url: process.env.VUE_APP_API_URL,
    api_host: process.env.VUE_APP_HOST_URL,
    api_login: process.env.VUE_APP_HOST_URL + 'login',
    api_map: process.env.KIY_GOOGLE_MAPS,
    push_key: process.env.WEB_PUSH_KEY,
    api_key: firebaseConfig.apiKey,
    token_key: "web-auth",
    ios_app_scheme: process.env.VUE_APP_IOS_APP_SCHEME,
    firebaseConfig: firebaseConfig,
    useEmulators: window.location.hostname === 'localhost',
    // Current Terms of Service version stamped onto user.tos_accepted_version
    // when they accept at signup. Bumping this string flips the router
    // beforeEach gate ON for every existing user — they'll be sent to
    // /legal/reaccept on their next navigation until they re-accept.
    // Bump this and the matching `tos_version` defaults in the signup
    // stores / forms in lockstep when counsel finalizes a new revision.
    tos_current_version: '2026-05-03',
    // Current Free Tier Partner Agreement version stamped onto
    // user.free_terms_accepted_version + tenant.free_terms_accepted_version
    // when the user accepts the inline partner agreement on
    // /sign_up/billing (only surfaced when an applied coupon code is a
    // "free-tier" coupon — its uppercase form contains "FREE"). Bump
    // this when counsel finalizes a new revision; future re-acceptance
    // flows can compare against this to detect drift.
    free_terms_current_version: '2026-05-04',
};

export default config;